









































import { Vue, Component, Mixins } from 'vue-property-decorator';

import MyForm from '@/mixins/form';

import SelectStadium from '@/components/selectstadium.vue';
import TsUpload from '@/components/upload.vue';

@Component({
  components: {
    SelectStadium,
    TsUpload,
  },
})
export default class extends Mixins(MyForm) {
  handleSubmit() {
    this.form.validateFields((err: any, fieldValues: any) => {
      if (!err) {
        this.$confirm({
          title: '确认信息',
          content: '你确定要导入吗？',
          onOk: async () => {
            this.confirmLoading = true;
            this.$store
              .dispatch('workorders/importVipExcel', fieldValues)
              .then((res) => {
                if (res && res.Message && res.Message === 'success') {
                  this.$message.success(res.Message);
                  this.handleCancel();
                } else {
                  this.$message.error(res.Message);
                }
                // console.log(res);
              });

            this.confirmLoading = false;
          },
        });
      }
    });
  }

  handleBeforeUpload(file: any) {
    this.form.validateFields((err: any, fieldValues: any) => {
      if (!err) {
        this.$confirm({
          title: '确认信息',
          content: '你确定要导入吗？',
          onOk: async () => {
            const params = new FormData();
            params.append('chunk', '0');
            params.append('chunks', '1');
            params.append('file', file, file.name);
            params.append('stadium_id', fieldValues.stadium_id);
            this.$store
              .dispatch('workorders/importVipExcel', params)
              .then((res) => {
                if (res && res.Message && res.Message === 'success') {
                  this.$message.success(res.Message);

                  this.handleCancel();
                } else {
                  this.$message.error(res.Message);
                }
                // console.log(res);
              });
          },
        });
      }
    });

    return false;
  }
}
